// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"OuterContainer_outerContainer__VvuoN","obscured":"OuterContainer_obscured__hdcPF"};